import { render, staticRenderFns } from "./GeneralLedgerCard.vue?vue&type=template&id=07ad71f6&"
import script from "./GeneralLedgerCard.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports